export interface CreditData {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: number;
  companyCode: string | null;
  originalCompanyName: string | null;
  divisionCode: string | null;
  locationCode: string | null;
  currentLocationName: string | null;
  currentReturnName: string | null;
  currentStateName: string | null;
  currentCountyName: string | null;
  currentCityName: string | null;
  currentTaxTypeName: string | null;
  dateCreated: Date | null;
  filingPeriodCreated: Date | null;
  totalCreditsAtPeriodBeginning?: number | null;
  stateCreditBalanceAmount: number | null;
  countyCreditBalanceAmount: number | null;
  cityCreditBalanceAmount: number | null;
  districtCreditBalanceAmount: number | null;
  stateCreditBalanceAmountApplied: number | null;
  countyCreditBalanceAmountApplied: number | null;
  cityCreditBalanceAmountApplied: number | null;
  districtCreditBalanceAmountApplied: number | null;
  remainingStateCreditBalanceAmount: number | null;
  remainingCountyCreditBalanceAmount: number | null;
  remainingCityCreditBalanceAmount: number | null;
  remainingDistrictCreditBalanceAmount: number | null;
  notesCount: number | null;
  totalRow: number | null;
}
